import { compose } from 'redux';
import { actionCreatorFactory, actionCreatorFactoryWithOpts } from './actionCreatorFactory';
import { curry } from 'ramda';

export const closeDialog = curry((dispatch, actions, dialog) =>
                             compose(dispatch, (...xs) => xs.length ?
                                actionCreatorFactoryWithOpts(actions[dialog], false, xs) :
                                actionCreatorFactory(actions[dialog], false)));

export const openDialog = curry((dispatch, actions, dialog) =>
                             compose(dispatch, (...xs) => xs.length ?
                                actionCreatorFactoryWithOpts(actions[dialog], true, xs) :
                                actionCreatorFactory(actions[dialog], true)));



// WEBPACK FOOTER //
// ./src/app/stores/dialogActions.js